import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { useTranslation } from "react-i18next";



const LEGAL_FORMS = [
  "legal.sole",
  "legal.llc",
  "legal.ltd",
  "legal.inc",
  "legal.corp",
  "legal.sarl",
  "legal.sa",
  "legal.sas",
  "legal.association",
  "legal.foundation",
  "legal.institution",
  "legal.partnership",
  "legal.holding"
];

const SECTORS = [
  "sector.textile",
  "sector.equipment",
  "sector.shoes",
  "sector.fitness",
  "sector.gym",
  "sector.nutrition",
  "sector.health",
  "sector.sportTech",
  "sector.media",
  "sector.events",
  "sector.travel",
  "sector.luxury",
  "sector.bank",
  "sector.education",
  "sector.association",
  "sector.commerce",
  "sector.automobile",
  "sector.food",
  "sector.sponsor"
];

export default function BrandForm() {
  const {
    handleChange,
    handleDetailsChange,
    formData,
    fieldErrors,
    details,
    setLegalForm,
    legalForm,
    PHONE_RULES,
    passwordStrength,
    countries
  } = useRegister();

  const { t } =
    useTranslation();

  const getCountryTranslation =
    (country) => {

      return t(
        `athleteForm.${country.toLowerCase()}`
      );

    };

  return (
    <form
      id="register-step-form"
      className="register-form-grid"
    >
      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.username ? "input-error" : ""
            }`}
          name="username"
          value={formData.username || ""}
          placeholder={
            t("athleteForm.username")
          }
          onChange={handleChange}
        />

        {fieldErrors.username && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.username}
          </div>
        )}
      </div>

      <input
        required
        className="register-inputs"
        name="legal_name"
        value={details.legal_name || ""}
        placeholder={
          t("brandForm.legalName")
        }
        onChange={handleDetailsChange}
      />

      <input
        required
        className="register-inputs"
        name="brand_name"
        value={details.brand_name || ""}
        placeholder={
          t("brandForm.brandName")
        }
        onChange={handleDetailsChange}
      />

      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.email ? "input-error" : ""
            }`}
          name="email"
          type="email"
          autoComplete="new-email"
          value={formData.email || ""}
          placeholder={
            t("athleteForm.email")
          }
          onChange={handleChange}
        />

        {fieldErrors.email && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.email}
          </div>
        )}
      </div>

      <div className="input-wrapper">
        <input
          className={`register-inputs ${fieldErrors.password
            ? "input-error"
            : passwordStrength.valid
              ? "input-success"
              : ""
            }`}
          type="password"
          name="password"
          autoComplete="new-password"
          placeholder={
            t("athleteForm.password")
          }
          value={formData.password || ""}
          onChange={handleChange}
        />

        {formData.password && (
          <>
            <div className="password-strength-bar">
              <span
                style={{
                  width: `${passwordStrength.score * 20}%`,
                }}
                className={
                  passwordStrength.score <= 2
                    ? "weak"
                    : passwordStrength.score <= 4
                      ? "medium"
                      : "strong"
                }
              />
            </div>

            <small className="password-message">
              {passwordStrength.message}
            </small>
          </>
        )}
      </div>

      <input
        required
        className="register-inputs"
        name="website"
        value={details.website || ""}
        placeholder={
          t("brandForm.website")
        }
        onChange={handleDetailsChange}
      />

      <input
        className='register-inputs'
        name='creation_date'
        value={details.creation_date}
        type="date"
        onChange={handleDetailsChange}
        required
      />

      <select
        required
        className="register-select"
        name="legal_form"
        value={details.legal_form || ""}
        onChange={(e) => {
          setLegalForm(e.target.value);
          handleDetailsChange(e);
        }}
      >
        <option value="">{t("brandForm.legalForm")}</option>

        {LEGAL_FORMS.map((form) => (
          <option
            key={form}
            value={form}
          >
            {t(form)}
          </option>
        ))}
      </select>

      <input
        required
        className="register-inputs"
        name="address"
        value={formData.address || ""}
        placeholder={
          t("athleteForm.address")
        }
        onChange={handleChange}
      />

      <SearchableCountrySelect
        required
        className="register-select"
        name="country"
        value={formData.country || ""}
        onChange={handleChange}
      >
        <option value="">{t("athleteForm.country")}</option>
        {countries.map((country) => (
          <option
            key={country.code}
            value={country.name}
          >
            {country.flag} {country.name}
          </option>
        ))}
      </SearchableCountrySelect>

      <select
        required
        className="register-select"
        name="language"
        value={formData.language}
        onChange={handleChange}
      >

        <option value="">
          {t("athleteForm.language")}
        </option>

        <option value="fr">
          🇫🇷 Français
        </option>

        <option value="en">
          🇬🇧 English
        </option>

        <option value="ar">
          🇲🇦 العربية
        </option>

        <option value="es">
          🇪🇸 Español
        </option>
        <option value="pt">🇵🇹 Português</option>
        <option value="zh">🇨🇳 中文（简体）</option>
        <option value="de">🇩🇪 Deutsch</option>
        <option value="ru">🇷🇺 Русский</option>
        <option value="it">🇮🇹 Italiano</option>
        <option value="sr">🇷🇸 Srpski</option>

      </select>

      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
            }`}
          name="phone"
          value={formData.phone || ""}
          placeholder={
            PHONE_RULES[formData.country]?.placeholder ||
            t("athleteForm.phone")
          }
          onChange={handleChange}
        />

        {fieldErrors.phone && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.phone}
          </div>
        )}
      </div>

      <select
        required
        className="register-select"
        name="sector"
        value={details.sector || ""}
        onChange={handleDetailsChange}
      >
        <option value="">
          {t("brandForm.sector")}
        </option>

        {SECTORS.map((sector) => (
          <option
            key={sector}
            value={sector}
          >
            {t(sector)}
          </option>
        ))}
      </select>
    </form>
  );
}
